// extracted by mini-css-extract-plugin
export default {"root":"_tSKEuIcVGZ8wQkoVV6P","menu":"ijoQSd3jGz13OiOghNHz","yali":"q4exsBVg6QcrdXfZz7yn","chat":"Zbf2vlBO3NF90py1Zqia"};